/**
 * ExpandToggle component for expanding/collapsing position rows.
 * Renders an accessible button with a rotating chevron icon.
 */

interface ExpandToggleProps {
  /** Whether the row is currently expanded */
  isExpanded: boolean;
  /** Position symbol for aria-label */
  symbol: string;
  /** Click handler */
  onToggle: () => void;
}

/**
 * Accessible expand/collapse toggle button with animated chevron.
 * Uses CSS rotation transition for smooth expand/collapse animation.
 */
export function ExpandToggle({ isExpanded, symbol, onToggle }: ExpandToggleProps) {
  const label = isExpanded
    ? `Collapse trades for ${symbol}`
    : `Expand trades for ${symbol}`;

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      aria-expanded={isExpanded ? 'true' : 'false'}
      aria-label={label}
      className="inline-flex items-center justify-center w-6 h-6 rounded text-gray-400 hover:text-gray-200 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors"
    >
      <span
        className="inline-block text-xs transition-transform duration-200 ease-in-out"
        style={{ transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)' }}
        aria-hidden="true"
      >
        ►
      </span>
    </button>
  );
}
